import { render } from "./SeedDetail.vue?vue&type=template&id=01a9b02f"
import script from "./SeedDetail.vue?vue&type=script&lang=js"
export * from "./SeedDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__